/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Roles_Is_Base_RoleInputs */

const en_tables_roles_is_base_role = /** @type {(inputs: Tables_Roles_Is_Base_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is Base Role`)
};

const de_tables_roles_is_base_role = /** @type {(inputs: Tables_Roles_Is_Base_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist Basisrolle`)
};

/**
* | output |
* | --- |
* | "Is Base Role" |
*
* @param {Tables_Roles_Is_Base_RoleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_roles_is_base_role = /** @type {((inputs?: Tables_Roles_Is_Base_RoleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Roles_Is_Base_RoleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_roles_is_base_role(inputs)
	return de_tables_roles_is_base_role(inputs)
});